module.exports = __webpack_public_path__ + "static/media/eye-solid.5ba208e0.svg";